import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router";
import "./PopupModal.scss";
import MODALMESSAGES from "Constants/Messages";
import STRINGS from "Constants/Strings";
import {
  EXPIRES_AT,
  REFRESH_EXPIRES_AT,
  S_APPLICANT_ID,
  S_CURRENT_MEMBER_ID,
  S_INSTNT_TXN_ID,
} from "../../Communication/Constants";
import { QRCodeSVG } from "qrcode.react";
import ROUTES from "../../Constants/AppConstants";
import { isInBranchFlow, isKycReportRequest } from "../../Utils/LogicUtilities";
import AppConstants from "../../Constants/AppConstants";

class PopupModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.showModal,
      qrUrl: "",
      qrCode: "",
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleClose = () => {
    console.log("handleClose");
    this.setState({ show: false });
  };

  unableToKyc = () => {
    console.log("unableToKyc");
    const { toggleKyc, skipKyc } = this.props;
    this.setState({ show: false }, () => {
      if (isKycReportRequest()) {
        skipKyc(false);
      } else {
        toggleKyc(false, true, true);
      }
    });
  };

  processNextStep = (override) => {
    const {
      doUpdateProductToVault,
      vaultProductList,
      getActiveProduct,
      history,
      refreshAboutYou,
      kycVault,
      doUpdateVault,
    } = this.props;
    let activeProduct = getActiveProduct(vaultProductList);
    if (isKycReportRequest()) {
      activeProduct = kycVault;
    }
    console.log("processNextStep", activeProduct);
    if (activeProduct.kycStatus === "started") {
      const qrCode = Math.floor(100000 + Math.random() * 900000);
      this.setState({
        qrCode,
        qrUrl:
          process.env.REACT_APP_BUCKET_URL +
          "signin?token=" +
          sessionStorage.getItem("token") +
          "&" +
          EXPIRES_AT +
          "=" +
          sessionStorage.getItem(EXPIRES_AT) +
          "&" +
          REFRESH_EXPIRES_AT +
          "=" +
          sessionStorage.getItem(REFRESH_EXPIRES_AT) +
          "&" +
          S_INSTNT_TXN_ID +
          "=" +
          sessionStorage.getItem(S_INSTNT_TXN_ID) +
          "&" +
          S_CURRENT_MEMBER_ID +
          "=" +
          (sessionStorage.getItem(S_CURRENT_MEMBER_ID) || "") +
          "&" +
          S_APPLICANT_ID +
          "=" +
          (sessionStorage.getItem(S_APPLICANT_ID) || "") +
          "&x=" +
          (isKycReportRequest() ? AppConstants.URL_FLAG.KYC_REPORT : "x"),
      });
      if (isKycReportRequest()) {
        activeProduct.kycStatus = "generate";
        activeProduct.kycQrCode = qrCode;
        doUpdateVault(activeProduct);
      } else {
        vaultProductList[0].kycStatus = "generate";
        vaultProductList[0].kycQrCode = qrCode;
        doUpdateProductToVault(vaultProductList);
      }
    } else if (
      activeProduct?.kycStatus === "mobileInProgress" ||
      activeProduct?.kycStatus === "mobileEnd"
    ) {
      refreshAboutYou(override);
    }
  };

  render() {
    const {
      showPopupModalButtons,
      toggleKyc,
      vaultProductList,
      getActiveProduct,
      skipKyc,
      refreshAboutYou,
      kycVault,
    } = this.props;
    const { show, qrUrl, qrCode } = this.state;
    console.log("qrUrl", qrUrl);
    let activeProduct = getActiveProduct(vaultProductList);
    if (isKycReportRequest()) {
      activeProduct = kycVault;
    }
    return (
      <>
        <Modal
          show={show}
          onHide={() => {
            this.handleClose();
            toggleKyc(false);
          }}
          className={"[ popup-modal__container kyc-qr ]"}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static" // this prevents the pop up from being closed when clicked outside of the pop up
          keyboard={false}
        >
          {!isInBranchFlow() && (
            <Modal.Header
              className="[ popup-modal__header ]"
              closeButton={showPopupModalButtons}
            >
              {activeProduct?.kycStatus === "started" && (
                <Modal.Title className={""}>
                  {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_INTRO_TITLE}
                </Modal.Title>
              )}
              {activeProduct?.kycStatus === "generate" && (
                <Modal.Title className={""}>
                  {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_DESKTOP_TITLE}
                </Modal.Title>
              )}
              {activeProduct?.kycStatus === "mobileStarted" && (
                <Modal.Title className={""}>
                  {
                    STRINGS.ABOUTYOU.KYC_QR_CODE
                      .QR_CODE_DESKTOP_MOBILE_STARTED_TITLE
                  }
                </Modal.Title>
              )}
              {(activeProduct?.kycStatus === "mobileInProgress" ||
                activeProduct?.kycStatus === "mobileEnd") && (
                <Modal.Title className={""}>
                  {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_DESKTOP_PAIRING_TITLE}
                </Modal.Title>
              )}
            </Modal.Header>
          )}

          {isInBranchFlow() &&
            !(
              activeProduct?.kycStatus === "mobileEnd" &&
              activeProduct?.kycResult !== "ACCEPT" &&
              isInBranchFlow()
            ) &&
            (activeProduct?.kycStatus === "generate" ||
              activeProduct?.kycStatus === "mobileStarted" ||
              activeProduct?.kycStatus === "mobileInProgress" ||
              activeProduct?.kycStatus === "mobileEnd") && (
              <Modal.Header
                className="[ popup-modal__header ]"
                closeButton={showPopupModalButtons}
              >
                {activeProduct?.kycStatus === "generate" && (
                  <Modal.Title className={""}>
                    {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_DESKTOP_TITLE}
                  </Modal.Title>
                )}
                {activeProduct?.kycStatus === "mobileStarted" && (
                  <Modal.Title className={""}>
                    {
                      STRINGS.ABOUTYOU.KYC_QR_CODE
                        .QR_CODE_DESKTOP_MOBILE_STARTED_TITLE
                    }
                  </Modal.Title>
                )}
                {(activeProduct?.kycStatus === "mobileInProgress" ||
                  (activeProduct?.kycStatus === "mobileEnd" &&
                    activeProduct?.kycResult === "ACCEPT" &&
                    isInBranchFlow())) && (
                  <Modal.Title className={""}>
                    {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_DESKTOP_PAIRING_TITLE}
                  </Modal.Title>
                )}
              </Modal.Header>
            )}

          <Modal.Body className="[ text-left ] [ overflow-auto ] [ iframe-popup-modal__body ]">
            {!isInBranchFlow() && activeProduct?.kycStatus === "started" && (
              <div className="[ mb-3 ]">
                <div className="[ mb-3 ] [ alert alert-warning ]">
                  <p>
                    {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INTRO_DESCRITPION}
                  </p>
                  <p>
                    {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INTRO_DESCRITPION1}
                  </p>
                </div>
                <div className="[ mb-3 ]">
                  <ul>
                    <li>
                      {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INTRO_DESCRITPION2}
                    </li>
                    <li>
                      {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INTRO_DESCRITPION3}
                    </li>
                    <li>
                      {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INTRO_DESCRITPION4}
                    </li>
                    <li>
                      {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INTRO_DESCRITPION5}
                    </li>
                    <li>
                      {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INTRO_DESCRITPION6}
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {activeProduct?.kycStatus === "generate" && (
              <>
                <div className="[ mb-3 text-center ]">
                  <div className="[ row ]">
                    <div className="[ col-12 ]">
                      {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INSTRUCTION}
                    </div>
                  </div>
                </div>
                <div className="[ mb-3 text-center ]">
                  <div className="[ row ]">
                    <div className="[ col-12 ]">
                      <QRCodeSVG value={qrUrl} />
                    </div>
                  </div>
                </div>
                <div className="[ mb-3 text-center ]">
                  <div className="[ row ]">
                    <div className="[ col-12 ]">
                      {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_INSTRUCTION1}
                    </div>
                  </div>
                </div>
              </>
            )}
            {activeProduct?.kycStatus === "mobileStarted" && (
              <>
                <div className="[ mb-3 ]">
                  <div className="[ row ]">
                    <div className="[ col-12 ]">
                      {
                        STRINGS.ABOUTYOU.KYC_QR_CODE
                          .QR_CODE_DESKTOP_MOBILE_STARTED_DESCRIPTION
                      }
                    </div>
                  </div>
                </div>
                <div className="[ mb-3 text-center ]">
                  <div className="[ row ]">
                    <div className="[ col-12 ]">
                      <b>{qrCode}</b>
                    </div>
                  </div>
                </div>
                <div className="[ mb-3 text-center ]">
                  <div className="[ row ]">
                    <div className="[ col-12 ]">
                      {
                        STRINGS.ABOUTYOU.KYC_QR_CODE
                          .QR_CODE_DESKTOP_MOBILE_STARTED_DESCRIPTION1
                      }
                    </div>
                  </div>
                </div>
              </>
            )}
            {(activeProduct?.kycStatus === "mobileInProgress" ||
              (activeProduct?.kycStatus === "mobileEnd" && !isInBranchFlow()) ||
              (activeProduct?.kycStatus === "mobileEnd" &&
                activeProduct?.kycResult === "ACCEPT" &&
                isInBranchFlow())) && (
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <p>
                      {
                        STRINGS.ABOUTYOU.KYC_QR_CODE
                          .QR_CODE_DESKTOP_PAIRING_DESCRIPTION
                      }
                    </p>
                    <p>
                      {
                        STRINGS.ABOUTYOU.KYC_QR_CODE
                          .QR_CODE_DESKTOP_PAIRING_DESCRIPTION1
                      }
                    </p>
                    <p>
                      {
                        STRINGS.ABOUTYOU.KYC_QR_CODE
                          .QR_CODE_DESKTOP_PAIRING_DESCRIPTION2
                      }
                    </p>
                  </div>
                </div>
              </div>
            )}

            {isInBranchFlow() &&
              (activeProduct?.kycStatus === "started" ||
                (activeProduct?.kycStatus === "mobileEnd" &&
                  activeProduct?.kycResult !== "ACCEPT")) && (
                <div className="kyc-failed-content">
                  {/* Warning Header */}
                  <div className="kyc-failed-warning-header">
                    <div className="warning-icon">!</div>
                  </div>
                  <Modal.Title style={{ textAlign: "center" }}>
                    Digital KYC Failed
                  </Modal.Title>
                  <div className="[ mb-4 ]">
                    {activeProduct?.kycStatus !== "mobileEnd" && (
                      <>
                        <p className="kyc-failed-description">
                          It appears we could not confidently verify the
                          identity of this person on our{" "}
                          <strong>initial attempt</strong>.
                        </p>

                        <p className="kyc-failed-description">
                          If your customer has their mobile device and a govt.
                          issued photo ID with them, they can try again using
                          the scan method.
                        </p>
                      </>
                    )}
                    {activeProduct?.kycStatus === "mobileEnd" && (
                      <p className="kyc-failed-description">
                        It appears we could not confidently verify the identity
                        of this person on our <strong>second attempt</strong>.
                      </p>
                    )}
                  </div>

                  <div className="[ mb-4 ]">
                    {activeProduct?.kycStatus !== "mobileEnd" && (
                      <h5 className="kyc-failed-question">
                        What would you like to do?
                      </h5>
                    )}
                    {activeProduct?.kycStatus === "mobileEnd" && (
                      <h5 className="kyc-failed-question">
                        Select one of the options to continue with this
                        application.
                      </h5>
                    )}
                  </div>

                  <div className="kyc-failed-options">
                    {/* Use Scan Method Button */}
                    {activeProduct?.kycStatus !== "mobileEnd" && (
                      <button
                        type="button"
                        className="kyc-failed-option-btn scan-method-btn [ mb-3 ]"
                        onClick={() => this.processNextStep()}
                      >
                        <div className="option-content">
                          <div className="option-icon scan-icon">
                            <div className="qr-squares">
                              <div className="qr-square"></div>
                              <div className="qr-square"></div>
                              <div className="qr-square"></div>
                              <div className="qr-square"></div>
                            </div>
                          </div>
                          <span className="option-text">
                            USE THE SCAN METHOD
                          </span>
                        </div>
                      </button>
                    )}

                    {/* Skip Scan Method Button */}
                    {activeProduct?.kycStatus !== "mobileEnd" && (
                      <button
                        type="button"
                        className="kyc-failed-option-btn skip-method-btn [ mb-3 ]"
                        onClick={() => skipKyc(true)}
                      >
                        <div className="option-content">
                          <div className="option-icon person-icon">
                            <div className="person-silhouette">
                              <div className="person-head"></div>
                              <div className="person-body"></div>
                              <div className="person-checkmark">✓</div>
                            </div>
                          </div>
                          <div className="option-text-container">
                            <div className="option-text-main">
                              {isKycReportRequest()
                                ? "Override Digital KYC Assertion"
                                : "SKIP THE SCAN METHOD"}
                            </div>
                            <div className="option-text-sub">
                              I have validated their ID face to face.
                            </div>
                          </div>
                        </div>
                      </button>
                    )}

                    {/* Manually override digital kyc */}
                    {activeProduct?.kycStatus === "mobileEnd" && (
                      <button
                        type="button"
                        className="kyc-failed-option-btn skip-method-btn [ mb-3 ]"
                        onClick={() => this.processNextStep(true)}
                      >
                        <div className="option-content">
                          <div className="option-icon person-icon">
                            <div className="person-silhouette">
                              <div className="person-head"></div>
                              <div className="person-body"></div>
                              <div className="person-checkmark">✓</div>
                            </div>
                          </div>
                          <div className="option-text-container">
                            <div className="option-text-main">
                              Override Digital KYC Assertion
                            </div>
                            <div className="option-text-sub">
                              I have validated their ID face to face.
                            </div>
                          </div>
                        </div>
                      </button>
                    )}

                    {/* Unable to KYC Button */}
                    <button
                      type="button"
                      className="kyc-failed-option-btn unable-kyc-btn [ mb-3 ]"
                      onClick={() =>
                        activeProduct?.kycStatus === "mobileEnd"
                          ? refreshAboutYou(false)
                          : this.unableToKyc()
                      }
                    >
                      <span className="option-text">
                        I was unable to confidently KYC this individual.
                      </span>
                    </button>
                  </div>
                </div>
              )}
          </Modal.Body>

          {!isInBranchFlow() && (
            <Modal.Footer className="[ popup-modal-footer ] [ d-block ]">
              {activeProduct?.kycStatus === "started" && (
                <>
                  <div className="[ mb-3 ]">
                    <div className="[ row ]">
                      <div className="[ col-12 ]">
                        <div>
                          <button
                            type="button"
                            className="[ btn submit-btn ] [ w-100 ]"
                            onClick={() => this.processNextStep()}
                          >
                            <span>
                              {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_BUTTON}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="[ mb-3 ]">
                    <div className="[ row ]">
                      <div className="[ col-12 text-center ]">
                        <div>
                          <p>
                            <span
                              className="[ link ]"
                              role="presentation"
                              onClick={() => skipKyc(false)}
                            >
                              {STRINGS.ABOUTYOU.KYC_QR_CODE.QR_CODE_BUTTON_SKIP}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Modal.Footer>
          )}

          {(activeProduct?.kycStatus === "mobileInProgress" ||
            (activeProduct?.kycStatus === "mobileEnd" &&
              activeProduct?.kycResult === "ACCEPT" &&
              isInBranchFlow()) ||
            (activeProduct?.kycStatus === "mobileEnd" &&
              !isInBranchFlow())) && (
            <Modal.Footer className="[ popup-modal-footer ] [ d-block ]">
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <div>
                      <button
                        type="button"
                        className="[ btn submit-btn ] [ w-100 ]"
                        onClick={() => this.processNextStep()}
                        disabled={
                          activeProduct?.kycStatus === "mobileInProgress"
                        }
                      >
                        <span>
                          {
                            STRINGS.ABOUTYOU.KYC_QR_CODE
                              .QR_CODE_DESKTOP_BUTTON_CONTINUE
                          }
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Footer>
          )}
        </Modal>
        <div></div>
      </>
    );
  }
}

PopupModal.propTypes = {
  showModal: PropTypes.bool,
  type: PropTypes.string,
  modalType: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  btnText: PropTypes.string,
  toggleModal: PropTypes.func,
  popupBtnClick: PropTypes.func,
  closeBtnClick: PropTypes.func,
  showPopupModalButtons: PropTypes.bool,
  iframeModal: PropTypes.bool,
  iframeUrl: PropTypes.string,
  footer: PropTypes.string,
  subtitle: PropTypes.string,
  addToVault: PropTypes.bool,
  tag: PropTypes.bool,
  seeDetailsClick: PropTypes.bool,
  shortDescription: PropTypes.string,
  customBtnClick: PropTypes.func,
  customBtnText: PropTypes.string,
  product: PropTypes.oneOfType([PropTypes.object]),
};

PopupModal.defaultProps = {
  showModal: false,
  type: "success",
  modalType: "",
  title: "",
  description: "",
  btnText: "OK",
  toggleModal: () => {},
  popupBtnClick: () => {},
  closeBtnClick: () => {},
  showPopupModalButtons: false,
  iframeModal: false,
  iframeUrl: "",
  footer: "",
  subtitle: "",
  addToVault: true,
  tag: false,
  seeDetailsClick: false,
  shortDescription: "",
  product: {},
  customBtnClick: () => {},
  customBtnText: "",
};

export default withRouter(PopupModal);
